import { Controller } from "@hotwired/stimulus"
import Pagy from "@/lib/pagy"

export default class extends Controller {
  static classes = ["active"]
  static targets = ["btn", "tab"]
  static values = { defaultTab: String }

  declare readonly activeClasses: string[]
  declare readonly btnTargets: HTMLElement[]
  declare readonly tabTargets: HTMLElement[]
  declare readonly defaultTabValue: string

  connect() {
    const urlTab = new URLSearchParams(window.location.search).get("tab")
    this.updateClasses(urlTab || this.defaultTabValue)
    document.addEventListener("turbo:load", this.onTurboLoad)
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.onTurboLoad)
  }

  select(event: Event) {
    const element = (event.target as HTMLElement).closest("[data-id]") as HTMLElement | null
    if (element) {
      const tabId = element.dataset.id!
      this.updateClasses(tabId)
      this.updateUrl(tabId)
    }
  }

  updateUrl(tabId: string) {
    const url = new URL(window.location.href)
    if (tabId === this.defaultTabValue) {
      url.searchParams.delete("tab")
    } else {
      url.searchParams.set("tab", tabId)
    }
    history.replaceState({}, "", url.toString())
  }

  onTurboLoad = () => {
    const urlTab = new URLSearchParams(window.location.search).get("tab")
    this.updateClasses(urlTab || this.defaultTabValue)
  }

  updateClasses = (selectedId: string) => {
    this.btnTargets.forEach((btn) => btn.classList.remove(...this.activeClasses))
    this.tabTargets.forEach((tab) => tab.classList.add("hidden"))

    this.btnTargets.forEach((btn) => {
      if (btn.dataset.id === selectedId) {
        btn.classList.add(...this.activeClasses)
      }
    })

    this.tabTargets.forEach((tab) => {
      if (tab.id === selectedId) {
        tab.classList.remove("hidden")
        Pagy.init(tab)
      }
    })
  }
}
